import React, { Component } from 'react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { token } from '@atlaskit/tokens';
import { FormattedMessage, injectIntl, type IntlShape } from '@atlassian/jira-intl';

import { InlineDialog, colors } from '@atlassian/jira-portfolio-3-common';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

type State = {
	isOpen: boolean;
};
const DEFAULT_INLINE_DIALOG_Z_INDEX = 300;

// eslint-disable-next-line jira/react/no-class-components
export class WarningDetails extends Component<Props & { intl: IntlShape }, State> {
	state = { isOpen: !!this.props.isOpen };

	onEnter = () => this.setState({ isOpen: true });

	onLeave = () => this.setState({ isOpen: false });

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	internationaliseNestedMessages = (values: { [key: string]: any }) => {
		const amount = values.amount
			? this.props.intl.formatMessage(values.amount.key, values.amount)
			: null;
		return { ...values, amount };
	};

	render() {
		const { warnings, opacity } = this.props;

		const content = (
			<div>
				{warnings &&
					warnings.map((warning, index) => (
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						<div key={index} className={styles.entryOld}>
							{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
							<div className={styles.heading}>
								{warnings.length > 1 && `${index + 1}. `}
								<FormattedMessage
									{...warning.header}
									values={this.internationaliseNestedMessages(warning.messageValues)}
								/>
							</div>
							{warning.message && (
								<div>
									<FormattedMessage
										{...warning.message}
										values={this.internationaliseNestedMessages(warning.messageValues)}
									/>
								</div>
							)}
						</div>
					))}
			</div>
		);

		return (
			<div
				onMouseOver={this.onEnter}
				onMouseLeave={this.onLeave}
				onFocus={this.onEnter}
				onBlur={this.onLeave}
			>
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					style={{ opacity }}
					data-testid="portfolio-3-portfolio.common.warning-details.warning-icon"
				>
					<WarningIcon
						label=""
						primaryColor={token('color.icon.warning', colors.Y300)}
						size="small"
					/>
				</div>
				{/* https://bulldog.internal.atlassian.com/browse/JPOS-4104
				 *  warnings messages should overlap optimize information
				 */}
				<InlineDialog
					zIndex={DEFAULT_INLINE_DIALOG_Z_INDEX + 1}
					content={content}
					isOpen={this.state.isOpen}
				>
					<div />
				</InlineDialog>
			</div>
		);
	}
}

export default injectIntl(WarningDetails);
